// noinspection JSUnusedGlobalSymbols

export type ConversationStatus =
  | 'unanswered'
  | 'refund'
  | 'debtor'
  | 'noted'
  | 'archive'
  | 'unread'
  | 'defectCheck'
  | 'delayed'
  | 'adminAssistance';

type CleanUserRole = 'admin' | 'employee' | 'client' | 'robot';

export type CleanUserOnboardingStatus = {
  id: number;
  catalog: boolean | null;
  card: boolean | null;
  order: boolean | null;
  isSkipped: boolean | null;
};

export type CleanUserSession = {
  id: number;
  userId: number;
  userAgent: string;
  ip: string;
  city: string | null;
  country: string | null;
  device: string | null;
  os: string | null;
  isCurrentSession: boolean;
  lastActive: Date;
};

export type CleanUserAccess =
  | 'purchase'
  | 'warehouse'
  | 'salesManager'
  | 'supplierFinances'
  | 'marketer'
  | 'transit'
  | 'financier'
  | 'reader'
  | 'fulfillment'
  | 'warehouseRussia'
  | 'headSalesManager'
  | 'systemAdmin'
  | 'operationsDirector'
  | 'customsDeliveryManager'
  | 'declarant';
export type CleanUser = {
  id: string;
  internalId: number | null;
  avatar?: CleanFile;
  disabled?: boolean;
  email?: string | null;
  name?: string | null;
  role?: CleanUserRole;
  phone?: string | null;
  accesses?: Array<CleanUserAccess>;
  createdAt?: string;
  updatedAt?: string;
  disableEmails?: boolean;
  supplier?: CleanSupplier;
  manager?: CleanUser;
  autoSend?: boolean;
  moderate?: boolean;
  moderateDeliveryOrder?: boolean;
  banType?: CleanBanType | null;
  banReason?: string | null;
  purchaseLimit?: string | null;
  autoWriteOffLimit?: string | null;
  otcommerceAsMainPage?: boolean;
  defaultSupplierId?: number | null;
  telegramMailing?: boolean;
  notifications?: Array<NotificationSetting>;
  telegramsStartParam?: string;
  userOnboardingStatus?: CleanUserOnboardingStatus | null;
  paymentMethodsModerationEnabled?: boolean;
  bitrixId?: string | null;
  bitrixLinkCode?: string | null;
};
export type NotificationChannel = 'sms' | 'email' | 'telegram';

export type NotificationType =
  | 'service'
  | 'promo'
  | 'order_chat'
  | 'finance'
  | 'security';

export type NotificationSetting = {
  type: NotificationType;
  sms: boolean;
  email: boolean;
  telegram: boolean;
};

export type CleanUserSelf = CleanUser &
  Required<
    Pick<CleanUser, 'avatar' | 'email' | 'name' | 'role' | 'phone' | 'accesses'>
  >;
export type CleanFile = {
  id: string;
  key: string;
  type: string;
};
export type CleanPurchaseOrderExpenses = CleanDeliveryOrderExpenses;
export type CleanPurchaseOrderType = 'purchase' | 'parcel';

export type SizesAndPricesType = {
  id: number;
  priceProduct: string;
};

export type ProductCardType = {
  id: number;
  disabled: boolean;
  originalId: string;
  link: string;
  productId: string;
  modificationId: string;
  name: string;
  coverId: number;
  sizesAndPrices: SizesAndPricesType[];
  description: string;
  characteristics: string;
  color: string;
  currency: 'rub' | 'cny' | 'usd';
};

type CleanPurchaseOrderStatus =
  | 'waitingForPayment'
  | 'inWork'
  | 'onTheWayToStock'
  | 'receivedInStock'
  | 'receivedInRetailStock'
  | 'sentToRussia'
  | 'canceled'
  | 'frozen'
  | 'hiddenFrozen';
type CleanPurchaseOrderCategory =
  | 'clothes'
  | 'householdGoods'
  | 'smallHouseholdGoods';
export type CleanPurchaseOrder = {
  id: string;
  type: CleanPurchaseOrderType;
  internalId: number;
  status: CleanPurchaseOrderStatus;
  cancelReason: string | null;
  user?: CleanUser;
  name: string | null;
  category: CleanPurchaseOrderCategory | null;
  link: string | null;
  catalogLink: string | null;
  trackNumber: string | null;
  comment: string | null;
  /** Товар Клиент */
  productPrice?: string;
  /** К оплате клиенту */
  price?: string;
  /** Комиссия за выкуп Факт */
  orderMarkup?: string | null;
  /** Комиссия за выкуп Клиент */
  preMarkup?: string;
  /** Доставка товаров до склада Клиент */
  deliveryPrice?: string;
  /** Фактические затраты */
  moderateFinalPrice?: string | null;
  /** Доставка товаров по Факт */
  moderateDeliveryPrice?: string | null;
  /** Товар Факт */
  moderateProductPrice?: string | null;
  volume: string | null;
  weight: string | null;
  length: number | null;
  width: number | null;
  height: number | null;
  /** Количество товара (штук), клиент */
  requestCount: number | null;
  /** Количество товара (штук), склад */
  count: number | null;
  /** Количество мест, клиент */
  requestPlaces: number | null;
  /** Количество мест, склад */
  places: number | null;
  storageLocation?: string | null;
  requestFilesV2: Array<CleanFileDto>;
  productFilesV2: Array<CleanFileDto>;
  receiptFilesV2: Array<CleanFileDto>;
  purchaseDate: string | null;
  paidAt: string | null;
  receiptDate: string | null;
  deliveryOrder?: CleanDeliveryOrder;
  createdAt: string;
  expenses?: CleanPurchaseOrderExpenses;
  updatedAt?: string;
  cancelledAt: string | null;
  freezingReason?: string | null;
  supplier?: CleanSupplier;
  supplierId?: number;
  autoSend: boolean;
  sendBlocked: boolean;
  unreadMessages?: number;
  currency?: CleanSupplierCurrency;
  additionalWriteOffs?: CleanPurchaseOrderWriteOff[];
  orderLink?: string | null;
  orderNumber?: string | null;
  orderAccount?: string | null;
  landingBill?: string | null;
  transportCompany?: string | null;
  receiptComment?: string | null;
  processingFromTerminal?: boolean;
  /** Дополнительные услуги (клиент) */
  serviceCharge?: string;
  /** Дополнительные услуги (факт) */
  moderateServiceCharge?: string;
  otcommerceVendor?: CleanVendorInfo;
  productCardId?: number;
  productCard?: ProductCardType | null;
  parentOrderUuid?: string | null;
  isSample?: boolean | null;
  supplierWarehouse?: CleanSupplierWarehouse | null;
  isRetail: boolean;
  retailInitAt?: string;
};

export type CleanVendorInfo = {
  providerType: string;
  vendorId: string;
  name: string;
  displayName: string | null;
  shopName: string | null;
};

export type CleanDeliveryMethodMethod =
  | 'air'
  | 'railway'
  | 'auto'
  | 'air_direct';
export type CleanDeliveryMethod = {
  id: string;
  name: string;
  method: CleanDeliveryMethodMethod;
  disabled?: boolean;
  deliveryPeriodFrom: number;
  deliveryPeriodTo: number | null;
  productCategories: Array<string>;
  tariffs: Array<{
    id: string;
    densityFrom: string;
    densityTo: string | null;
    price: string;
    createdAt: string;
  }>;
  forCalculator?: boolean;
  createdAt: string;
  updatedAt: string;
  supplier?: CleanSupplier;
  destination?: CleanLocation;
  minWeight?: string;
  maxWeight?: string;
};
type CleanAddressType = 'legal' | 'individual' | 'pickupPoint';
export type CleanAddress = {
  id: string;
  name: string;
  phone: string;
  city: string;
  type: CleanAddressType;
  companyInn: string | null;
  companyName: string | null;
  passport: string | null;
  pickupPoint: string | null;
  cdekCode: string | null;
  createdAt: string;
  updatedAt: string;
  fullAddress: string | null;
};
export type CleanDeliveryOrderExpenses =
  | {
      client: string;
      company?: string;
    }
  | undefined;
type CleanDeliveryOrderStatus =
  | 'processing'
  | 'assembly'
  | 'assembled'
  | 'packaged'
  | 'sentToRussia'
  | 'receivedInRussia'
  | 'receivedInRetailRussia'
  | 'sentToRecipient'
  | 'delivered'
  | 'retail';
type CleanRetailPickupPoint =
  | {
      address: string;
      city?: string;
      userPhone?: string;
      lastMileName?: string;
      lockerContractor?: string;
      lockerContractorICN?: string;
    }
  | undefined;
type CleanRetailDescription =
  | {
      descriptionRu: string;
      descriptionEn: string;
      descriptionZh: string;
    }
  | undefined;

type CleanRetailDeliveryEvent = {
  eventCode: string;
  eventText?: string;
  eventComment?: string;
  eventPlace?: string;
  partner?: string;
  eventTime: string;
};
type CleanRetailPassportData = {
  surname: string;
  firstName: string;
  patronymic?: string;
  passport: string;
  inn: string;
  email: string;
};

export type CleanRetailDeliveryOrder = {
  hwbRefNumber?: string;
  hwbNumber?: string;
  isAttention?: boolean;
  lastEvent?: CleanRetailDeliveryEvent;
  pickupPoint?: CleanRetailPickupPoint;
  description?: CleanRetailDescription;
  passportData?: CleanRetailPassportData;
};
export type CleanDeliveryOrder = {
  id: string;
  internalId: number;
  user?: CleanUser;
  status: CleanDeliveryOrderStatus;
  transportationType?: 'standalone' | 'combined';
  transportation?: {
    type: 'standalone' | 'combined';
    name: string;
    id: string;
    receivedAt?: string | null;
  };
  packagedDate: string | null;
  sentDate: string | null;
  receiveRfDate: string | null;
  sentToRecipientDate: string | null;
  deliveredDate: string | null;
  trackNumber: string | null;
  packageMethods: string | null;
  purchaseOrders: Array<CleanPurchaseOrder> | undefined;
  packageGroups: Array<CleanPackageGroup> | undefined;
  moderateProductPrice?: string;
  deliveryMethod?: CleanDeliveryMethod;
  localDeliveryMethod: CleanLocalDeliveryMethod;
  address?: CleanAddress;
  packedFilesV2: Array<CleanFileDto>;
  waybillFilesV2: Array<CleanFileDto>;
  count: number | null;
  weight: string | null;
  volume: string | null;
  storageLocation: string | null;
  prePrice?: string;
  price?: string | null;
  deliveryPrice?: string | null;
  packagePrice?: string | null;
  insurancePrice?: string | null;
  markupPrice?: string | null;
  moderateDeliveryPrice?: string | null;
  moderatePackagePrice?: string | null;
  moderateInsurancePrice?: string | null;
  moderateMarkupPrice?: string | null;
  paid?: boolean;
  expenses?: CleanDeliveryOrderExpenses;
  createdAt: string;
  updatedAt?: string;
  blocked?: boolean;
  localDeliveryPrice?: string | null;
  moderateLocalDeliveryPrice?: string | null;
  supplier?: CleanSupplier;
  supplierId?: number;
  supplierLocation?: CleanLocation;
  compositeDelivery?: CleanCompositeDelivery;
  unreadMessages?: number;
  currency?: CleanSupplierCurrency;
  /** Дополнительные услуги (клиент) */
  serviceCharge?: string;
  /** Дополнительные услуги (факт) */
  moderateServiceCharge?: string;
  cdekOrder?: CleanCdekOrder;
  cdekAddress?: string;
  retailOrder?: CleanRetailDeliveryOrder;
};
export type CleanFileDto = {
  id: string;
  type: 'pdf' | 'image' | 'video' | 'unknown';
  size: number;
};

export type CleanPackageMethod = {
  id: string;
  disabled?: boolean;
  name: string;
  comment: string | null;
  createdAt: string;
  updatedAt: string;
  tariffs: Array<CleanPackageMethodTariff>;
  supplier?: CleanSupplier;
};
type CleanPackageMethodTariff = {
  id: string;
  volumeFrom: string;
  volumeTo: string | null;
  price: string;
  createdAt: string;
};
export type CleanMoneyBill = {
  cny: string;
  usd: string;
  bonus: string;
};

export type CleanMoneyWriteOffBill = {
  cny: string;
  usd: string;
};

export type CleanBalanceSuppliers = Array<{
  id: number;
  name: string;
  balance: CleanMoneyBill;
}>;

export type CleanBalance = CleanMoneyBill & {
  suppliers?: CleanBalanceSuppliers;
};

export type CleanDeliveryOrderDeliveryMarkup = {
  id: string;
  priceTo: string;
  markup: string;
  createdAt?: string;
  updatedAt?: string;
};

const AuditLogObject = {
  AlipayWallet: 'AlipayWallet',
  Currency: 'Currency',
  DeliveryInsurance: 'DeliveryInsurance',
  DeliveryMethod: 'DeliveryMethod',
  DeliveryOrder: 'DeliveryOrder',
  DeliveryOrderDeliveryMarkup: 'DeliveryOrderDeliveryMarkup',
  DeliveryOrderPackageGroup: 'DeliveryOrderPackageGroup',
  PackageMethod: 'PackageMethod',
  PurchaseOrder: 'PurchaseOrder',
  PurchaseOrderClientExpensesPurchaseMarkup:
    'PurchaseOrderClientExpensesPurchaseMarkup',
  PurchaseOrderClientExpensesPurchaseMarkupTariff:
    'PurchaseOrderClientExpensesPurchaseMarkupTariff',
  PurchaseOrderDeliveryTariff: 'PurchaseOrderDeliveryTariff',
  TopUpCardToCardAccount: 'TopUpCardToCardAccount',
  TopUpMethod: 'TopUpMethod',
  Transaction: 'Transaction',
  User: 'User',
  WeChatWallet: 'WeChatWallet',
  AutoSendParameters: 'AutoSendParameters',
  CompositeDeliveryOrder: 'CompositeDeliveryOrder',
  Promotion: 'Promotion',
  CustomsDeliveryOrder: 'CustomsDeliveryOrder',
  CustomsDeliveryOrderPriceData: 'CustomsDeliveryOrderPriceData',
  CustomsDeliveryOrderCalculationSettings:
    'CustomsDeliveryOrderCalculationSettings',
  CustomsDeliveryOrderDuty: 'CustomsDeliveryOrderDuty',
  CustomsDeliveryMethod: 'CustomsDeliveryMethod',
  CustomsDeliverySupport: 'CustomsDeliverySupport',
  CustomsDeliveryOrderInvoice: 'CustomsDeliveryOrderInvoice',
};
type AuditLogObject = (typeof AuditLogObject)[keyof typeof AuditLogObject];

export type CleanAuditLog = {
  id: number;
  createdAt: string;
  object: AuditLogObject;
  objectId: number | null;
  objectInternalId: number | null;
  objectUuid: string | null;
  action: 'insert' | 'update' | 'delete';
  userId: number | null;
  user: CleanUser | undefined;
  data: { diff: { [Key in string]: { new: unknown; old: unknown } } };
  comment: string | null;
};

export type CleanProfile = CleanUserSelf & {
  permissions: Record<string, string[]>;
  featureFlags: string[];
  withVk?: boolean;
  withYandex?: boolean;
  withPassword?: boolean;
};

export enum RbacRole {
  Admin = 'ROLE_ADMIN',
  Client = 'ROLE_CLIENT',
  Employee = 'ROLE_EMPLOYEE',
  Warehouse = 'ROLE_WAREHOUSE',
  Purchase = 'ROLE_PURCHASE',
  SalesManager = 'ROLE_SALES_MANAGER',
  SupplierFinances = 'ROLE_SUPPLIER_FINANCES',
  Marketer = 'ROLE_MARKETER',
  Transit = 'ROLE_TRANSIT',
  Financier = 'ROLE_FINANCIER',
  Reader = 'ROLE_READER',
  Fulfillment = 'ROLE_FULFILLMENT',
  WarehouseRussia = 'ROLE_WAREHOUSE_RUSSIA',
  CustomsDeliveryManager = 'ROLE_CUSTOMS_DELIVERY_MANAGER',
  Declarant = 'ROLE_DECLARANT',
}

export enum RbacObject {
  Account = 'Account',
  Affiliate = 'Affiliate',
  AuditLog = 'AuditLog',
  AutoSendParameters = 'AutoSendParameters',
  Balance = 'Balance',
  CompositeDeliveryOrder = 'CompositeDeliveryOrder',
  Conversation = 'Conversation',
  Currency = 'Currency',
  DeliveryInsurance = 'DeliveryInsurance',
  DeliveryMethod = 'DeliveryMethod',
  DeliveryOrder = 'DeliveryOrder',
  DeliveryAddress = 'DeliveryAddress',
  DeliveryOrderDeliveryMarkup = 'DeliveryOrderDeliveryMarkup',
  LocalDeliveryMethod = 'LocalDeliveryMethod',
  Location = 'Location',
  OtcRecommendation = 'OtcRecommendation',
  PackageMethod = 'PackageMethod',
  Parcel = 'Parcel',
  PoizonCard = 'PoizonCard',
  Promotion = 'Promotion',
  Purchase = 'Purchase',
  PurchaseMarkup = 'PurchaseMarkup',
  PurchaseOrderClientExpensesPurchaseMarkup = 'PurchaseOrderClientExpensesPurchaseMarkup',
  PurchaseOrderDeliveryTariff = 'PurchaseOrderDeliveryTariff',
  ServiceChargeOption = 'ServiceChargeOption',
  Story = 'Story',
  Supplier = 'Supplier',
  TopUpMethod = 'TopUpMethod',
  Transaction = 'Transaction',
  User = 'User',
  Cdek = 'Cdek',
  Transportation = 'Transportation',
  Utm = 'Utm',
  EmailCampaign = 'EmailCampaign',
  TempAccessSession = 'TempAccessSession',
  CustomsDelivery = 'CustomsDelivery',
  FeatureFlag = 'FeatureFlag',
}

export const RbacObjectActionsMap = {
  [RbacObject.Account]: ['read', 'write', 'connect', 'write:client'],
  [RbacObject.Affiliate]: ['read'],
  [RbacObject.AuditLog]: ['read'],
  [RbacObject.AutoSendParameters]: ['read', 'write'],
  [RbacObject.Balance]: ['convert', 'read:admin'],
  [RbacObject.CompositeDeliveryOrder]: ['read', 'write'],
  [RbacObject.Conversation]: ['read:all'],
  [RbacObject.Currency]: ['read', 'write'],
  [RbacObject.DeliveryInsurance]: ['read', 'write'],
  [RbacObject.DeliveryMethod]: ['read', 'write'],
  [RbacObject.DeliveryAddress]: ['read', 'write', 'delete'],
  [RbacObject.DeliveryOrderDeliveryMarkup]: ['read', 'write'],
  [RbacObject.DeliveryOrder]: [
    'read',
    'read:available',
    'read:methods',
    'calculateActual',
    'read:transactions',
    'write:markSentToRussia',
    'read:assembly-info',
    'read:actual-finances',
    'write',
    'write:address',
    'delete',
    'read:finances-client',
    'read:finances-company',
    'read:transit',
    'write:markDelivered',
    'read:notes',
    'write:notes',
    'read:address',
    'send-to-assembly',
    'reassign-transportation',
    'read:warehouse-russia',
    'write:revert-received-in-russia',
  ],
  [RbacObject.EmailCampaign]: ['read:admin', 'write:admin'],
  [RbacObject.LocalDeliveryMethod]: ['read', 'write'],
  [RbacObject.Location]: ['read:admin', 'write:admin'],
  [RbacObject.OtcRecommendation]: ['read:admin', 'write:admin'],
  [RbacObject.PackageMethod]: ['read', 'write'],
  [RbacObject.Parcel]: [
    'read',
    'write:admin-create',
    'write:client',
    'write:admin',
    'cancel',
    'write:related-parcel',
  ],
  [RbacObject.PoizonCard]: ['read:admin', 'write:admin'],
  [RbacObject.Promotion]: ['read', 'write'],
  [RbacObject.PurchaseMarkup]: ['read'],
  [RbacObject.PurchaseOrderClientExpensesPurchaseMarkup]: ['read', 'write'],
  [RbacObject.PurchaseOrderDeliveryTariff]: ['read', 'write'],
  [RbacObject.Purchase]: [
    'read',
    'read:client-total',
    'read:actual-total',
    'read:transactions',
    'cancel',
    'write:client-finances',
    'write:actual-finances',
    'write:client',
    'write:admin-create',
    'confirmPurchase',
    'write:admin',
    'confirmReceipt',
    'freeze',
    'unfreeze',
    'hiddenFreeze',
    'read:finances-company',
    'read:finances-client',
    'read:extended-statuses',
    'read:finances-company',
    'delete:while-waiting-on-payment',
    'write:while-waiting-on-payment',
    'write:while-in-work',
    'write:confirmation',
    'write:additionalWriteOff',
    'read:notes',
    'write:notes',
    'write:receipt-data',
    'write:metadata',
    'write:supplier',
    'read:supplier',
    'read:hiddenPurchase',
    'read:report',
    'write:share',
  ],
  [RbacObject.ServiceChargeOption]: ['read:admin', 'write:admin'],
  [RbacObject.Story]: ['read:client', 'read:admin', 'write:admin'],
  [RbacObject.Supplier]: ['read:admin', 'write:admin'],
  [RbacObject.TopUpMethod]: [
    'write',
    'write:proof',
    'read:accounts',
    'read:calculate',
    'read:admin',
    'read:client',
    'write:admin',
    'write:client',
  ],
  [RbacObject.Transaction]: [
    'read:admin',
    'write:admin',
    'read:supplier',
    'write:expenses',
    'write:additional-service',
    'read:report',
    'read:report-act',
  ],
  [RbacObject.User]: [
    'read:admin',
    'write:admin',
    'write:toggles',
    'link',
    'unlink',
    'impersonate',
    'link:admin',
    'unlink:admin',
    'read:phone',
    'read:writeoff',
  ],
  [RbacObject.Cdek]: ['read'],
  [RbacObject.Transportation]: ['read', 'write', 'write:send', 'write:receive'],
  [RbacObject.Utm]: ['read', 'write'],
  [RbacObject.TempAccessSession]: ['read', 'write'],
  [RbacObject.CustomsDelivery]: [
    'read',
    'write',
    'read:settings',
    'write:settings',
    'write:declarant',
  ],
  [RbacObject.FeatureFlag]: ['read:admin', 'write:admin'],
} as const;

export type CleanCurrency = {
  id: number;
  uuid: string;
  cnyExternal: string;
  cnyInternal: string;
  usdExternal: string;
  usdInternal: string;
  usdRubExternal: string | null;
  cnyUsdExternal: string | null;
  usdRubInternal: string | null;
  cnyUsdInternal: string | null;
  usdRubPartner: string | null;
  cnyRubPartner: string | null;
  createdAt: string;
};

/**
 * @deprecated
 */
type DeprecatedCurrencyType = 'usdCnyCryptomus' | 'cnyUsdCryptomus';
type CurrencyType =
  | 'cnyRubExternal'
  | 'cnyRubInternal'
  | 'cnyRubPartner'
  | 'usdRubExternal'
  | 'usdRubInternal'
  | 'usdRubPartner'
  | 'usdCny'
  | 'cnyUsd'
  | 'usdRubPartnerP2P'
  | 'cnyRubPartnerP2P'
  | 'cnyRubCbr'
  | 'usdRubCbr'
  | DeprecatedCurrencyType;
export type CleanCurrency2 = {
  id: number;
  type: CurrencyType;
  rate: string;
  createdAt: string;
};

type TopupV2CreateRedirectResponse = {
  type: 'redirect';
  data: {
    url: string;
  };
};

type TopupV2CreateOpenTransactionPageResponse = {
  type: 'open_transaction_page';
  data: {
    id: string;
  };
};

type TopupV2CreatePopUpWindowResponse = {
  type: 'pop-up';
  data: {
    url: string;
  };
};

type TopupV2CreateCryptomusWalletResponse = {
  type: 'cryptomus_wallet';
  data: {
    uuid: string;
    amountUsdt: string;
    amountInCurrency: string;
  };
};
type TopupV2CreateCryacqWalletResponse = {
  type: 'cryacq_wallet';
  data: {
    uuid: string;
    amountUsdt: string;
    amountInCurrency: string;
  };
};

export type TopupV2CreateResponse =
  | TopupV2CreateRedirectResponse
  | TopupV2CreateOpenTransactionPageResponse
  | TopupV2CreatePopUpWindowResponse
  | TopupV2CreateCryptomusWalletResponse
  | TopupV2CreateCryacqWalletResponse;

export interface CleanLocalDeliveryMethod {
  id: string;
  disabled?: boolean;
  name: string;
  slug: string;
  priority?: number | null;
  createdAt?: string;
  updatedAt?: string;
  supplier?: CleanSupplier;
  location?: CleanLocation;
  selfDelivery?: boolean;
  isFulfillment?: boolean;
  isCdek?: boolean;
  cdekFee?: string;
  priceClient?: string;
  commentClient?: string | null;
  priceSupplier?: string;
  commentSupplier?: string | null;

  minWeight?: string;
  maxWeight?: string;

  clientAdditionalInfoLabel?: string | null;
  filteredDeliveryMethods?: CleanDeliveryMethod[];
  logo?: CleanFileDto;
}

export type CleanPackageGroup = {
  id: number;
  methods: CleanPackageMethod[];
  purchaseOrders: CleanPurchaseOrder[];
};

export type CleanSupplierCurrency = 'usd' | 'cny' | 'try';

export type CleanSupplier = {
  id: number;
  name: string;
  addressForParcels: string;
  location?: CleanLocation;
  purchaseCurrency: CleanSupplierCurrency;
  deliveryCurrency: CleanSupplierCurrency;
  disabled: boolean;
  deliveryOrderCombineRule?: {
    enabled: boolean;
    json?: string;
    deliveryMethodId?: string;
  };
  priority?: number | null;
  warehouses?: CleanSupplierWarehouse[];
  userLimitToCargo?: number | null;
};

export type CleanSupplierWarehouse = {
  id: number;
  supplierId: number;
  location?: CleanLocation | null;
  locationId: number;
  isDefault?: boolean | null;
};

export type CleanPurchaseOrderDeliveryTariff = {
  id: string;
  disabled?: boolean;
  priceTo: string;
  markup: string;
  createdAt?: string;
  updatedAt?: string;
  supplier?: CleanSupplier;
};

export type CleanLocation = {
  id: number;
  name: string;
  displayName: string;
  country: string | null;
  city: string | null;
  isCustomsDelivery: boolean | null;
};

export type DirectionLocation = {
  id: number;
  name: string;
  country: string | null;
  city: string | null;
  isCustomsDelivery: boolean | null;
};

type DirectionSupplier = {
  id: number;
  address: string;
  purchaseCurrency: CleanSupplierCurrency;
  deliveryCurrency: CleanSupplierCurrency;
  priority?: number | null;
};

export type CleanDirection = {
  supplier: DirectionSupplier;
  from: DirectionLocation;
  to: Array<DirectionLocation>;
};

export type CleanAutoSendParameters = {
  id: number;
  supplier?: CleanSupplier;
  localDeliveryMethod?: CleanLocalDeliveryMethod;
  deliveryMethod?: CleanDeliveryMethodMethod | null;
  volume: string;
  price: string;
  count: number;
  weight: string;
};
export type CleanCompositeDeliveryExpenses =
  | {
      client: string;
      company?: string;
    }
  | undefined;
type CleanCompositeDeliveryStatus =
  | 'assembly'
  | 'sentToRussia'
  | 'receivedInRussia';
export type CleanCompositeDelivery = {
  id: string;
  internalId: number;
  status: CleanCompositeDeliveryStatus;
  sentDate: string | null;
  receiveRfDate: string | null;
  createdAt: string;
  updatedAt?: string;
  deliveryOrders: Array<CleanDeliveryOrder> | undefined;
  moderateProductPrice?: string;
  moderateDeliveryPrice?: string | null;
  moderatePackagePrice?: string | null;
  moderateInsurancePrice?: string | null;
  moderateMarkupPrice?: string | null;
  prePrice?: string;
  price?: string | null;
  deliveryPrice?: string | null;
  packagePrice?: string | null;
  insurancePrice?: string | null;
  markupPrice?: string | null;
  expenses?: CleanCompositeDeliveryExpenses;
};

export type LanguageCode = 'ru' | 'zh' | 'en';

export type MessageType =
  | 'robotOutOfWorkingMessage'
  | 'robotFirstOrderMessage'
  | 'robotRateMessage'
  | 'robotRateFeedbackMessage'
  | 'robotAddressChangeMessage'
  | 'robotCustomsOrderInvoiceMessage'
  | 'robotOrderDimensionsMessage';

export type CleanMessage = {
  id: number;
  user: CleanUser;
  message: string;
  attachments: Array<CleanFile>;
  sentAt: string;
  read: boolean;
  languageCode: LanguageCode | null;
  translatedMessage: string | null;
  type: MessageType | null;
};

export type CleanConversationType = 'client' | 'supplier';
export type CleanConversation = {
  id: string;
  purchaseOrder?: CleanPurchaseOrder;
  deliveryOrder?: CleanDeliveryOrder;
  customsDeliveryOrder?: CleanCustomsDeliveryOrder;
  type: CleanConversationType;
  lastMessage?: CleanMessage;
  unread: number;
  status?: string; // @deprecated
  statuses?: ConversationStatus[];
};

export type CleanCurrencyCurrentV2 = {
  cnyRubInternal: string;
  cnyRubExternal: string;
  cnyRubPartner: string;
  usdRubInternal: string;
  usdRubExternal: string;
  usdRubPartner: string;
  usdCny?: string;
  cnyUsd?: string;
  usdRubPartnerP2P?: string;
  cnyRubPartnerP2P?: string;
  usdRubCbr?: string;
  cnyRubCbr?: string;
};

export type CleanCurrencyCurrentCross = {
  usdCnyInternal: string;
  usdCnyExternal: string;
};

export type CleanPromotionType = 'commission' | 'bonus';
export type CleanPromotionUsage = 'allOrders' | 'firstOrder' | 'nextOrder';

export type CleanPromotion = {
  id: string;
  name?: string;
  displayName: string;
  displayDescription: string;
  type: CleanPromotionType;
  usage: CleanPromotionUsage;
  markup?: string;
  bonus?: number;
  bonusLifetime?: number;
  startDate: string;
  endDate: string;
  paymentDate?: string;
  createdAt?: string;
  updatedAt?: string;
  disabled?: boolean;
  users?: CleanUser[];
  banner?: CleanFile;
  promocode?: string;
  referrer?: CleanUser;
  promocodeUsers?: number;
  referrals?: CleanUser[];
};

export type CleanDeliveryInsurance = {
  id: string;
  name: string;
  disabled?: boolean;
  tariffs: Array<{
    id: string;
    pricePerKgFrom: string;
    pricePerKgTo: string;
    percent: string;
    createdAt: string;
  }>;
  createdAt: string;
  updatedAt: string;
  supplier: CleanSupplier;
};
type CleanBanType = 'full' | 'newPurchases';
export const PromocodePattern = /^[a-zA-ZА-Я0-9!-]+$/;

export const ConversionModificator = 1;

export const ConversionLimit = 4;

type Journal =
  | 'additionalPaymentForDeliveryOrder'
  | 'additionalPaymentForPurchaseOrder'
  | 'additionalServiceCharge'
  | 'additionalServiceChargeExpense'
  | 'affiliateCommissionForDeliveryOrder'
  | 'affiliateCommissionForPurchaseOrder'
  | 'convertCurrency'
  | 'depositByAlipay'
  | 'depositByCard'
  | 'depositByCash'
  | 'depositByCryacqWallet'
  | 'depositByCryptomus'
  | 'depositByCryptomusWallet'
  | 'depositByCryptocloud'
  | 'depositByInvoice'
  | 'depositByOverpay'
  | 'depositByOverpaySbp'
  | 'depositByPayKeeperCard'
  | 'depositByPayKeeperSbp'
  | 'depositByPayselection'
  | 'depositByPromotion'
  | 'depositBySbp'
  | 'depositByWata'
  | 'depositByWataSbp'
  | 'depositByWechat'
  | 'depositCompany'
  | 'expensesForDeliveryOrder'
  | 'expensesForPurchaseOrder'
  | 'paymentForDeliveryOrder'
  | 'paymentForPurchaseOrder'
  | 'refundAdditionalServiceCharge'
  | 'refundAdditionalServiceChargeExpense'
  | 'refundForDeliveryOrder'
  | 'refundForPurchaseOrder'
  | 'supplierExpense'
  | 'withdraw';

export type CleanTransaction = {
  amount: string;
  metadata: Partial<{
    /** Конвертация баланса: id связанного списания */ relatedWithdrawalTransactionId: number;
    /** Конвертация баланса: id связанного зачисления */ relatedRefillTransactionId: number;
    /** Крипта партнёр: признак */ cryptoCreatedFromCash: true;
    /** Крипта партнёр: uuid транзакции из которой создали */ originalCashTransactionUuid: string;
    /** Бонусные рубли: id промо акции */ promotionId: number;
    /** Бонусные рубли: дата экспирации */ bonusExpiresAt: string;
  }> | null;
  accountName?: string;
  walletType: string | null;
  fee?: string | null;
  txid: number;
  userAmount?: string | null;
  userAmountRub?: string | null;
  currencyRateInternal?: string | null;
  type: 'writeOff' | 'refill';
  privateComment?: string | null;
  externalAmount?: string | null;
  createdAt: string;
  feeAmount?: string | null;
  journal: Journal;
  createdBy?: CleanUser;
  supplier?: CleanSupplier;
  comment: string | null;
  currency: string;
  id: string;
  currencyRateExternal?: string | null;
  user: { internalId: number; manager?: { name: string | null } | null };
  status: 'canceled' | 'draft' | 'processing' | 'confirmed';
  updatedAt: string;
  operationName?: string;
  statusDescription?: string;
  proofFileId?: number | null;
  proofFile?: CleanProofFile;
  cardHolderName?: string | null;
  qrFile?: CleanFile;
  cardNumber?: string | null;
  billNumber?: number;
  billDate?: string;
  billLink?: string;
  invoiceLink?: string;
  internalTransaction?: true;
  purchaseOrder?: CleanPurchaseOrder;
  bonus?: true;
  deliveryOrder?: CleanDeliveryOrder;
  cryptomusInvoices?: Array<CleanCryptopmusInvoice>;
  topUpCurrency: 'usd' | 'rub' | 'cny' | 'usdt' | 'bonus' | null;
  cryptocloudInvoices?: Array<unknown>;
  sbpFile?: CleanFile & {
    sbpLink?: string;
  };
  cryacqInvoices?: Array<CleanCryacqInvoice>;
};
export type CleanProofFile = {
  id: string;
  originalName: string;
  type: string;
};
export type CleanCryptopmusInvoice = {
  status: string;
  network: 'tron' | 'eth' | 'ton';
  txid: string;
  amount: string;
  amountUsdt: string;
  createdAt: string;
};

export type CleanCryacqInvoice = {
  status: string;
  network: 'tron' | 'eth' | 'ton';
  txid: string;
  amount: string;
  amountUsdt: string;
  createdAt: string;
};

export type CleanPurchaseOrderWriteOff = {
  amount: string;
  description?: string;
  createdAt: string;
  receiptFiles: CleanFile[];
};

export type CleanNote = {
  id: number;
  user: CleanUser;
  noteText: string;
  createdAt: string;
  updatedAt: string;
  attachments?: Array<CleanFile>;
};

export const CdekTariffCode = 136;
export const CdekServices = [
  { code: 'NOTIFY_ORDER_DELIVERY' },
  { code: 'NOTIFY_ORDER_CREATED' },
];

export type CleanCdekOrder = {
  id: number;
  deliveryOrderId: number;
  cdekUuid: string | null;
  receiptUuid: string | null;
  barcodeUuid: string | null;
  pointCode: string;
  recipientCost: number | null;
};

export type CleanTransportationWaybill = {
  id: string;
  packedFiles: CleanFileDto[];
  waybillFiles: CleanFileDto[];
  count: number;
  weight: string;
  volume: string;
  insurancePrice: string | undefined;
  deliveryPrice: string | undefined;
  packagePrice: string | undefined;
  comment: string | undefined;
  createdAt: string;
  updatedAt: string;
};

export type CleanTransportationLine = {
  id: string;
  deliveryOrder: CleanDeliveryOrder;
  assignedAt: string;
};
export type CleanTransportationPacking = {
  id: number;
  count: number;
  weight: string;
  volume: string;
  storageLocation: string | null;
  packedFiles: CleanFileDto[];
  createdAt: string;
};
export type CleanTransportation = {
  id: string;
  type: 'standalone' | 'combined';
  name: string;
  methodType: string;
  methodName: string;
  deliveryPeriodFrom: number;
  deliveryPeriodTo: number | null;
  supplier: CleanSupplier;
  destination: CleanLocation | null;
  lines: CleanTransportationLine[];
  waybill: CleanTransportationWaybill | null;
  productPrice: string | null;
  receivedAt: string | null;
  createdAt: string;
  updatedAt: string;
  packing: CleanTransportationPacking | null;
};

export enum CustomsDeliveryVat {
  base = 'base',
  baseV2 = 'baseV2',
  gg = 'gg',
  ld = 'ld',
}

export enum CustomsDeliveryCurrency {
  cny = 'cny',
  usd = 'usd',
  rub = 'rub',
}

export type PurchaseOrderWithRelations = {
  parentOrder?: {
    type: CleanPurchaseOrderType;
    internalId: string;
    uuid: string;
  };
  relatedPurchaseOrders?: Array<{
    type: CleanPurchaseOrderType;
    internalId: number;
    uuid: string;
  }>;
};

export type DeliveryOrderRate = {
  id: number;
  rate: number;
  deliveryOrderId: number;
};

export type TempAccessSession = {
  id: number;
  createdAt: Date;
  isDenied: boolean | null;
  accesses: CleanUserAccess[];
  schedule: TempAccessSessionSchedule[];
  reason: string;
};

export type TempAccessSessionSchedule = {
  id: number;
  sessionId: number;
  startedAt: Date;
  finishedAt: Date;
};

export type CustomsDeliveryOrderStatus =
  | 'created'
  | 'preparing'
  | 'codeSelected'
  | 'calculationReady'
  | 'protectCalculation'
  | 'prepareDocs'
  | 'prepareInvoice'
  | 'declarant'
  | 'waitingForPayment'
  | 'buyOut'
  | 'inWork'
  | 'inStock'
  | 'sentToRussia'
  | 'customs'
  | 'transitWarehouse'
  | 'transferredToTC'
  | 'received'
  | 'archived';

export type CleanCustomsDeliveryOrderDeliveryType = 'sea' | 'railway' | 'auto';

export type CleanCustomsDeliveryOrder = {
  id: string;
  name: string;
  link: string | null;
  comment: string | null;
  createdAt: Date;
  inWorkAt: Date | null;
  preparingAt: Date | null;
  calculationReadyAt: Date | null;
  codeSelectedAt: Date | null;
  waitingForPaymentAt: Date | null;
  buyOutAt: Date | null;
  inStockAt: Date | null;
  sentToRussiaAt: Date | null;
  customsAt: Date | null;
  transitWarehouseAt: Date | null;
  transferredToTCAt: Date | null;
  receivedAt: Date | null;
  protectCalculationAt: Date | null;
  prepareDocsAt: Date | null;
  prepareInvoiceAt: Date | null;
  declarantAt: Date | null;
  archivedAt: Date | null;
  userId: number;
  user?: CleanUser;
  internalId: number;
  status: CustomsDeliveryOrderStatus;
  volume: number | null;
  weight: number | null;
  estimatedVolume: number | null;
  price: number | null;
  files: Array<CleanFileDto>;
  amount: number | null;
  city: string | null;
  isSentForRevision: boolean | null;
  deliveryType: CleanCustomsDeliveryOrderDeliveryType | null;
  receiptCity: string | null;
  documentTypes: Array<string>;
  bitrixDealId: string | null;
  goods: CleanCustomsDeliveryOrderGood[];
  supplier?: CleanSupplier;
  priceData?: CleanCustomsDeliveryOrderPriceData;
  purchaseOrder?: CleanPurchaseOrder;
};

export type CleanCustomsDeliveryOrderGoodToll = {
  id: number;
  customsDeliveryOrderGoodId: number;
  total: number | null;
  rate: string;
  createdAt: Date;
};

export type CleanCustomsDeliveryOrderGood = {
  id: number;
  customsDeliveryOrderId: number;
  name: string;
  codeTariff: string | null;
  amount: number | null;
  price: number | null;
  currency: 'rub' | 'cny' | 'usd' | null;
  feeSum: number | null;
  tollsSum: number | null;
  vatSum: number | null;
  totalSum: number | null;
  tolls?: CleanCustomsDeliveryOrderGoodToll[];
  createdAt: Date;
  vat: CustomsDeliveryVat | null;
};

export type CustomsDeliveryOrderCalculationSettings = {
  id: number;
  estimatedVolumeRate: number;
  pRRRate: number;
  pRRRateForThreshold: number | null;
  pRRRateThreshold: number | null;
  markingCargoSpace: number;
  insurance: number;
  declaration: number;
  trueSignOrderMarking: number;
  trueSignApplyMarking: number;
  bankCommission: number;
  bankCommissionConstant: number | null;
  bankCommissionThreshold: number | null;
  cnyRateCommission: number | null;
  usdRateCommission: number | null;
  createdAt: Date;
};

export type CleanCustomsDeliveryOrderPriceData = {
  id: number;
  totalPricePaid: number | null;
  totalPrice: number | null;
  cargoPlaces: number | null;
  cargoPlacesPrice: number | null;
  operationsPrice: number | null;
  logisticPrice: number | null;
  individualLogisticPrice: number | null;
  packagePrice: number | null;
  insurancePrice: number | null;
  customsDutyPrice: number | null;
  vatPrice: number | null;
  additionalCustomsFeePrice: number | null;
  customsFeePrice: number | null;
  declarationPrice: number | null;
  invoicePrice: number | null;
  bankCommissionPrice: number | null;
  trueSignOrderMarkingPrice: number | null;
  trueSignApplyMarkingPrice: number | null;
  estimatedVolumeRate: number | null;
  pRRRate: number | null;
  markingCargoSpaceRate: number | null;
  insuranceRate: number | null;
  trueSignOrderMarkingRate: number | null;
  trueSignApplyMarkingRate: number | null;
  bankCommissionRate: number | null;
  bankCommissionConstant: number | null;
  additionalSupportPrice: number | null;
  customsDeliverySupportPrice: number | null;
  customsDeliveryOrderId: number;
  vat: number | null;
  usdRubRateCbr: number | null;
  cnyRubRateCbr: number | null;
  usdRubCommission: number | null;
  cnyRubCommission: number | null;
  createdAt: Date | null;
  updatedAt: Date | null;
  customsDeliveryMethod?: CleanCustomsDeliveryMethod | null;
  customsDeliverySupport?: CleanCustomsDeliverySupport | null;
};

export type CleanCustomsDeliveryDuty = {
  id: number;
  rate: number;
  fromPrice: number | null;
  toPrice: number | null;
  goodCode: string | null;
  createdAt: Date;
};

export type CleanCustomsDeliveryTrueSignTariff = {
  id: number;
  rate: number;
  type: 'forApply' | 'forOrder';
  fromAmount: number | null;
  toAmount: number | null;
  createdAt: Date;
};

export type CleanCustomsDeliveryMethodMethod =
  | 'air'
  | 'railway'
  | 'auto'
  | 'air_direct'
  | 'sea';

export enum CustomsDeliveryMethodType {
  air = 'air',
  railway = 'railway',
  auto = 'auto',
  air_direct = 'air_direct',
  sea = 'sea',
}

export type CleanCustomsDeliveryMethod = {
  id: string;
  name: string;
  method: CleanCustomsDeliveryMethodMethod;
  disabled?: boolean;
  deliveryPeriodFrom: number;
  deliveryPeriodTo: number | null;
  tariffs: Array<{
    id: string;
    weightFrom: string;
    weightTo: string | null;
    price: string;
    createdAt: string;
  }>;
  createdAt: string;
  updatedAt: string;
  supplier?: CleanSupplier;
};

export type CleanCustomsDeliverySupport = {
  id: string;
  name: string;
  disabled?: boolean;
  period: number;
  tariffs: Array<{
    id: string;
    commissionRate: number;
    price: string;
    createdAt: string;
  }>;
  createdAt: string;
  updatedAt: string;
  threshold?: number;
};

export type CleanAccountType = 'company' | 'entrepreneur';

export type CleanAccount = {
  id: number;
  uuid: string;
  internalId: number;
  type: CleanAccountType;
  name: string;
  inn: string;
  ogrn: string;
  address: string;
  management: string | null;
  kpp: string | null;
  mdId: number | null;
  ownerId: number;
};

export type CleanCustomsDeliveryOrderInvoice = {
  id: number;
  uuid: string;
  isPaid: boolean;
  customsDeliveryOrderId: number;
  createdAt: Date;
  updatedAt: Date;
  account?: CleanAccount;
  receiverAccount?: CleanCustomsOrderInvoiceAccount;
  goods?: CleanCustomsDeliveryOrderInvoiceGood[];
};

export type CleanCustomsDeliveryOrderInvoiceGood = {
  id: number;
  uuid: string;
  name: string;
  price: number;
  amount: number;
  unit: string;
  customsDeliveryOrderInvoiceId: number;
  createdAt: Date;
  updatedAt: Date;
};

export type CleanCustomsOrderInvoiceAccount = {
  id: number;
  uuid: string;
  name: string;
  shortName: string;
  inn: string;
  address: string;
  kpp?: string | null;
  ogrn?: string | null;
  disabled: boolean;
  signing?: CleanFileDto | null;
  stamp?: CleanFileDto | null;
  vatValue?: number | null;
  accountBanks: CleanCustomsOrderInvoiceAccountBank[];
};

export type CleanCustomsOrderInvoiceAccountBank = {
  id: number;
  uuid: string;
  account: string;
  bankName: string;
  bankBic: string;
  bankAccount: string;
  bankAddress: string;
  bankInn: string;
  disabled: boolean;
};
